import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'

export const HeaderLogo: React.FC = () => {
  return (
    <StyledLink href="/">
      <Image src="/images/proxysphere_for_dark_navbar.svg" width="173" height="18" alt="Tumelo logo" />
    </StyledLink>
  )
}

const StyledLink = styled(Link)`
  align-self: center;
  min-width: 79px;
  display: flex; // Ensures image is centered vertically within anchor
`
